
import React from 'react'
import OccupationalTherapy from '../ServicesComponents/OccupationalTherapy';
import EarlyIntervention from './EarlyIntervention';

const Programs = () => {
  return (
    <div>
        <EarlyIntervention/>
    </div>
  )
}

export default Programs;